module.exports = __webpack_public_path__ + "static/binaria_generica_rrss-48756dd05fa728099883614616a6e051.jpg";